<template>
  <div class="h-full relative overflow-auto flex flex-col overflow-x-hidden">
    <div class="sticky top-0 z-[2] pageHeader">
      <slot name="header">
        <div class="p-5 md:p-8">
          <div class="mobile-status-padding"></div>
          <div class="flex justify-between items-center">
            <!-- <slot name="headerLeft">
              <div class="w-full"></div>
            </slot> -->
            <slot name="headerCenter">
              <div class="w-full text-2xl md:text-3xl title-color text-start font-bold">
                <slot name="headerTitle"> - </slot>
              </div>
            </slot>
            <slot name="headerRitht">
              <div class="w-full flex justify-end min-w-12">
                <!-- <button
                  @click="$bus.emit($constants.EVENTS.AFFILIATION.OPEN)"
                  class="w-10 h-10 bg-white p-2 min-w-10 rounded-full font-bold text-2xl flex items-center justify-center text-gray-500"
                >

                  <div class="w-5 h-5 p-0.5">
                    <ColorImg
                      src="/images/navs/networking.svg"
                      class="w-full h-full bg-current"
                    />
                  </div>
                </button> -->
              </div>
            </slot>
          </div>
        </div>
      </slot>
    </div>
    <div
      class="w-full h-full pageBody pb-32 md:pb-8 overflow-auto overflow-x-hidden"
      :style="{ backgroundColor: `${$attrs.bodyBg} !important` }"
    >
      <slot></slot>
    </div>
  </div>
</template>
